import { AlertColor } from '@mui/material';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface alertSliceState {
    show: boolean;
    severity: AlertColor | null;
    text: string | null;
}

const initialState: alertSliceState = {
    show: false,
    severity: null,
    text: null,
};

export const alertSlice = createSlice({
    name: 'alert',
    initialState: initialState,
    reducers: {
        openAlert(
            state,
            action: PayloadAction<{
                displayText: string;
                severity: AlertColor;
            }>,
        ) {
            state.text = action.payload.displayText;
            state.severity = action.payload.severity;
            state.show = true;
        },

        closeAlert(state) {
            state.show = false;
            state.text = null;
            state.severity = null;
        },
    },
});

export const { openAlert, closeAlert } = alertSlice.actions;
